module.exports = __webpack_public_path__ + "img/philadelphia-brigade.1cf62c38.png";